import { render, staticRenderFns } from "./SingleCouncil.vue?vue&type=template&id=eb542108&scoped=true&"
import script from "./SingleCouncil.vue?vue&type=script&lang=ts&"
export * from "./SingleCouncil.vue?vue&type=script&lang=ts&"
import style0 from "./SingleCouncil.vue?vue&type=style&index=0&id=eb542108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb542108",
  null
  
)

export default component.exports